<div class="{{inputClasses}} pr-4 mt-[16px] mb-[16px]">
  <label class="block mb-2 font-medium text-gray-900 relative">

    <span
      class="{{required ? requiredClasses : ''}}"
      [ngClass]="{ disabled: isDisabled }">{{label}}</span>
    <psc-info-icon [iconColorClass]="infoIconColorClass" [infoText]="infoText"
                   [sizeInPx]="infoIconSize"></psc-info-icon>
    <output
      *ngIf="value || value === 0"
      class="range-tooltip absolute rounded {{bgColorClass}} -translate-x-1/2 py-[4px] px-[12px] text-color-white font-bold -translate-y-1/3 {{tooltipArrowColorClass}} after:border-b-transparent after:border-r-transparent after:border-l-transparent"
      [style.left]="calculateLeft()">{{ value }}</output>
    <input type="range"
           [disabled]="isDisabled"
           [ngModel]="value"
           (ngModelChange)="onModelChange($event)"
           [min]="min"
           [max]="max"
           [step]="step"
           class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer {{sliderColorClass}}">
  </label>
  <div class="relative h-2">
    <div *ngFor="let stepLabel of stepLabels; let i = index"
         class="absolute -translate-x-1/2" [style.left]="(i*100)/(stepLabels.length - 1) + '%'">
      {{stepLabel}}
    </div>
  </div>

  <psc-input-error
    [control]="formControl"></psc-input-error>
</div>
